import { Moon, Sun } from 'lucide-react';
import { useState } from 'react';
import { NavLink, Route, Routes } from 'react-router-dom';
import { classNames } from './lib/format.js';
import { Admin } from './routes/Admin.js';
import { Dashboard } from './routes/Dashboard.js';
import { Employees } from './routes/Employees.js';
import { Events } from './routes/Events.js';
import { Lookup } from './routes/Lookup.js';

const NAV = [
  ['/', 'Map'],
  ['/events', 'Advisories'],
  ['/lookup', 'Travel Lookup'],
  ['/employees', 'Employees'],
  ['/admin', 'Admin'],
] as const;

export function App() {
  const [light, setLight] = useState(false);

  const toggleTheme = () => {
    const next = !light;
    setLight(next);
    document.documentElement.classList.toggle('light', next);
    document.documentElement.classList.toggle('dark', !next);
  };

  return (
    <div className="flex h-full flex-col">
      <nav className="flex items-center gap-1 border-b border-[var(--color-border)] bg-[var(--color-bg)] px-3 py-1.5">
        {NAV.map(([to, label]) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              classNames(
                'rounded px-3 py-1.5 text-sm transition',
                isActive
                  ? 'bg-[var(--color-panel-2)] text-[var(--color-text)]'
                  : 'text-[var(--color-muted)] hover:text-[var(--color-text)]',
              )
            }
          >
            {label}
          </NavLink>
        ))}
        <button
          type="button"
          onClick={toggleTheme}
          className="ml-auto rounded p-1.5 text-[var(--color-muted)] hover:bg-[var(--color-panel-2)]"
          aria-label="Toggle theme"
        >
          {light ? <Moon size={15} /> : <Sun size={15} />}
        </button>
      </nav>
      <main className="flex-1 overflow-y-auto">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/employees" element={<Employees />} />
          <Route path="/events" element={<Events />} />
          <Route path="/lookup" element={<Lookup />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
    </div>
  );
}
